import { render } from "./FormVehicleCars.vue?vue&type=template&id=f6bd3866"
import script from "./FormVehicleCars.vue?vue&type=script&lang=js"
export * from "./FormVehicleCars.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__